import clsx from 'clsx';
import { forwardRef } from 'react';

import { type ButtonHookProps, useButton } from '../Button';
import { type ImageProps, ProgressiveImage } from '../Image';
import { Card } from './Card';

export interface CardWrapperButtonProps extends Omit<ButtonHookProps, 'elementType'> {
    image: Omit<ImageProps, 'rounded'>;
    children: React.ReactNode;
    className?: string;
}

export const CardWrapperButton = forwardRef(function CardWrapperButton(
    props: CardWrapperButtonProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    const { image, children, className, ...rest } = props;

    const { buttonProps } = useButton({ ...rest, elementType: 'div' });
    return (
        <div
            ref={ref}
            {...buttonProps}
            className={clsx(
                'group/outer-card-btn',
                'flex flex-col gap-3',
                'focus-visible:ring-2 focus-visible:ring-focus',
                className
            )}
        >
            <Card
                kind="glass"
                className="relative flex overflow-hidden transition-shadow ease-in-out group-hover/outer-card-btn:shadow-elevated"
            >
                <ProgressiveImage
                    {...image}
                    rounded={false}
                    className={clsx('w-full object-cover', image.className)}
                />
            </Card>
            <div>{children}</div>
        </div>
    );
});
